module.exports = __webpack_public_path__ + "img/ico_member.a57dad54.svg";